/// <amd-module name="Reporting/BoardsCommon/BoardsRoutingHelper" />
import { IVssPageContext } from "VSS/Platform/Context";
import { isFeatureEnabled } from "VSS/Platform/Feature";
import { FastPageSwitch } from "VSS/Platform/FPS";
import { routeUrl } from "VSS/Platform/Location";
import { getCurrentRoute } from "VSS/Platform/Navigation";

export function isBacklogsPage(): boolean {
    return window.location.href.indexOf("_backlogs") >= 0;
}

export function chooseAnalyticsRootRoute(): string {
    return isBacklogsPage() ? "ms.vss-work-web.backlogs-content-route" : "ms.vss-work-web.team-board-content-route";
}

export function getBoardsAnalyticsRootUrl(pageContext: IVssPageContext): string {
    const route = getCurrentRoute(pageContext);
    const revisedRouteValues = {
        project: route.routeValues.project,
        teamName: route.routeValues.teamName,
        pivot: "analytics"
    };
    const targetRoute = chooseAnalyticsRootRoute();
    const destination = routeUrl(pageContext, targetRoute, revisedRouteValues);
    return destination;
}
/** Gets a Boards or Backlog page report Url */
export function getBoardsReportUrl(pageContext: IVssPageContext, categoryName: string, reportName?: string) {
    const route = getCurrentRoute(pageContext);
    const revisedRouteValues: { [key: string]: string } = {
        project: route.routeValues.project,
        teamName: route.routeValues.teamName,
        backlogLevel: categoryName, // Note: Route information on legacy boards pages is not updated in intra-hub navigation or UI interactions, so this is driven from props.
        pivot: "analytics"
    };

    if (reportName != null) {
        revisedRouteValues["report"] = reportName;
    }

    const routeId = isBacklogsPage()
        ? isFeatureEnabled(pageContext, "ms.vss-work-web.new-boards-hub-feature", false)
            ? "ms.vss-work-web.new-backlogs-content-route"
            : "ms.vss-work-web.backlogs-content-route"
        : "ms.vss-work-web.team-board-content-route";
    return routeUrl(pageContext, routeId, revisedRouteValues);
}

/** Gets a Sprints page report Url */
export function getSprintsReportUrl(pageContext: IVssPageContext) {
    const route = getCurrentRoute(pageContext);
    const revisedRouteValues: { [key: string]: string } = {
        project: route.routeValues.project,
        teamName: route.routeValues.teamName,
        iteration: route.routeValues.iteration,
        pivot: "analytics"
    };

    const routeId = isFeatureEnabled(pageContext, "ms.vss-work-web.new-boards-hub-feature", false)
        ? "ms.vss-work-web.new-sprints-content-route"
        : "ms.vss-work-web.sprints-content-route";
    return routeUrl(pageContext, routeId, revisedRouteValues);
}

export function getNavigateToBoardHandler(context: IVssPageContext): () => void {
    return (): void => {
        const route = getCurrentRoute(context);
        const revisedRouteValues = {
            project: route.routeValues.project,
            teamName: route.routeValues.teamName,
            backlogLevel: route.routeValues.backlogLevel,
            pivot: "board"
        };

        // We want to take the user to the boards page, so they can materialize the board for this backlogLevel
        const routeId = "ms.vss-work-web.team-board-content-route";
        const destination = routeUrl(context, routeId, revisedRouteValues);
        const recordHistoryEntry = true;
        FastPageSwitch(context, destination, recordHistoryEntry);
    };
}
